import { ToolInvocationUIPart } from 'ai'
import { cn } from '@/lib/utils'

const GetStepScreenshotMessage = ({
  part,
  icon,
}: {
  part: ToolInvocationUIPart
  icon: React.ReactNode
}) => {
  // const result =
  //   part.toolInvocation.state === 'result' ? part.toolInvocation.result : null
  // const stepId: string | null = part.toolInvocation.args.stepId ?? null
  // console.log('>>> article generation', part, stepId, result)
  /* FIXME(@ai-sdk-upgrade-v5): The `part.toolInvocation.state` property has been removed. Please manually migrate following https://ai-sdk.dev/docs/migration-guides/migration-guide-5-0#tool-part-type-changes-uimessage */
  return (
    <div className='flex w-full flex-col items-start gap-0'>
      <div
        className='group/icon inline-flex h-auto w-full min-w-16 items-center justify-start gap-2 bg-transparent px-3 py-2.5 hover:bg-transparent'
        // onClick={() => setShowDetails(!showDetails)}
      >
        <div className='flex w-4 flex-shrink-0 items-center justify-center'>
          <div>{icon}</div>
        </div>
        <span
          className={cn(
            'text-foreground flex-1 text-left text-[14px] leading-5 font-medium tracking-[0] break-words whitespace-normal'
          )}
        >
          {part.toolInvocation.state === 'result'
            ? `Examined step screenshot`
            : `Examining step screenshot...`}
        </span>
        {/* <ChevronUp
          className={cn('size-4 transition-transform duration-300', {
            'rotate-180': !showDetails,
          })}
          strokeWidth={2}
        /> */}
      </div>
    </div>
  )
}

export default GetStepScreenshotMessage
